// src/components/admin/design/DealsPreview.tsx
"use client";

import UniversalProductCardPreview from "./UniversalProductCardPreview";

export interface DealsPreviewProps {
  variantId: string;
  primaryColor?: string;
  theme?: "dark" | "light";
  subdomain?: string;
}

export default function DealsPreview({
  variantId = "timer_urgency",
  primaryColor = "#059669",
  theme,
  subdomain,
}: DealsPreviewProps) {
  return (
    <UniversalProductCardPreview
      sectionTitle="Deals of the Day"
      variantId={variantId}
      primaryColor={primaryColor}
      showTimer={true}
      theme={theme}
      subdomain={subdomain}
    />
  );
}